<template lang="pug">
.usuarios.container.grid-lg.py-2
  form.usuario(@submit.prevent="save")
    .card(v-if="current")
      .card-header
        .card-title
          h5 {{ current.login | cpfCnpj }}&nbsp;
            span {{ current.nome }}
      .card-body(v-if="usuario")
        .form-group
          label.form-label(for="email") {{ "usuario.email" | tModel }}
          input#email.form-input(type="email", v-model="usuario.email")
        .form-group
          label.form-label(for="nome") {{ "usuario.nome" | tModel }}
          input#nome.form-input(type="text", v-model="usuario.nome")
        .form-group
          label.form-label {{ "usuario.validado_por" | tModel }}
          label.form-radio(v-for="v in validado_por_list")
            input(
              type="radio",
              name="validado_por",
              v-model="usuario.validado_por",
              :value="v"
            )
            i.form-icon
            b {{ ("enums.db.enum_usuario_validado_por." + v) | translate }}
        .form-group(v-if="usuario.is_fisica")
          label.form-label(for="prefeitura") Trabalha na prefeitura
          label.form-switch
            input#prefeitura(type="checkbox", v-model="usuario.prefeitura")
            i.form-icon
            |
            | Tem acesso ao sistema interno da prefeitura
        .form-group(v-if="usuario.prefeitura")
          label.form-switch
            input#recebe_os(type="checkbox", v-model="usuario.recebe_os")
            i.form-icon
            |
            | {{ "usuario.recebe_os" | tModel }}
        .form-group(v-if="usuario.prefeitura")
          label.form-switch
            input#fiscal(type="checkbox", v-model="usuario.fiscal")
            i.form-icon
            |
            | {{ "usuario.fiscal" | tModel }}
        .form-group
          label.form-label(for="matricula") {{ "usuario.matricula" | tModel }}
          input#matricula.form-input(
            type="text",
            v-model="usuario.matricula",
            :disabled="!usuario.prefeitura"
          )
        .form-group
          label.form-label(for="codigo_fiscal") {{ "usuario.codigo_fiscal" | tModel }}
          input#codigo_fiscal.form-input(
            type="text",
            v-model="usuario.codigo_fiscal",
            :disabled="!usuario.prefeitura"
          )
        .form-group
          label.form-label(for="usuario_grupo") {{ "usuario.usuario_grupo" | tModel }}
          usuario-grupo-picker(v-model="usuario.usuario_grupo_id")
        .form-group
          label.form-label {{ "usuario.cargo" | tModel }}
          cargo-picker(v-model="usuario.cargo_id")
        .form-group
          label.form-label(for="data_admissao") {{ "usuario.data_admissao" | tModel }}
          datepicker(
            v-model="usuario.data_admissao",
            :disabled="!usuario.prefeitura"
          )
        .form-group
          label.form-label {{ "usuario.perfis" | tModel }}
          perfis(v-model="usuario.perfis", :disabled="!usuario.prefeitura")
        .form-group(v-if="usuario.prefeitura")
          label.form-label {{ "usuario.assuntos" | tModel }}
          assuntos-picker(v-model="usuario.assunto_ids")
        .form-group(v-if="usuario.prefeitura")
          label.form-label {{ "usuario.zonas" | tModel }}
          zonas-picker(v-model="usuario.zona_ids")
      .card-footer.text-right(:disabled="loading")
        router-link.primary.btn.btn-link.mr-2(
          :to="{ name: 'app.sistema.usuarios.show', params: { id: current.id } }"
        )
          btn-content(name="show")
        button.btn.btn-primary(:class="{ loading: loading }", type="submit")
          btn-content(name="save")
</template>

<script>
import Usuario from "@/models/Usuario"
import Perfis from "@/components/usuarios/Perfis"

export default {
  vuex: {
    "sistema/usuarios": {
      state: ["current"],
      actions: ["fetchOne", "fetchUpdate"],
      getters: ["loading"],
    },
  },
  components: { Perfis },
  data() {
    return { usuario: null, validado_por_list: [] }
  },
  methods: {
    isFetchOne() {
      return (
        !this.current ||
        Number(this.current.id) !== Number(this.$route.params.id)
      )
    },
    setUsuario() {
      this.usuario = new Usuario(this.current)
      delete this.usuario.endereco
      delete this.usuario.pessoa
      this.validado_por_list = [this.current.validado_por]
      if ("nenhum" === this.current.validado_por) {
        this.validado_por_list.push("pessoalmente")
      }
    },
    save() {
      this.fetchUpdate(this.usuario)
        .then(() => {
          this.$toaster.success("Salvo com sucesso.")
          this.$router.replace({ name: "app.sistema.usuarios" })
        })
        .catch((e) => {
          this.$toaster.error(this.$parseErrors(e).join(", "))
        })
    },
  },

  created() {
    if (this.isFetchOne()) {
      this.fetchOne(this.$route.params.id).then(this.setUsuario)
    } else {
      this.setUsuario()
    }
  },
}
</script>

<style src="./usuarios.styl" lang="stylus"></style>
